import {Organization} from "./organization.model.ts";
import {Feature} from "./feature.model.ts";


export const PermissionLevels = {
  NONE: 0b0000,   // 0 - None
  VIEW: 0b0001,   // 1 - View
  UPDATE: 0b0010, // 2 - Update
  CREATE: 0b0100, // 4 - Create
  DELETE: 0b1000, // 8 - Delete

  /*
    USAGE | Checking Permissions

    user?.permissions.hasAccess("Employees", PermissionLevels.UPDATE);

    Checking Mult Permissions
    user?.permissions.hasAccess("Employees", PermissionLevels.VIEW | PermissionLevels.CREATE);

   */
};


export class Permission {

  organizations: Organization[];
  features: Feature[];
  is_super_user: boolean;

  constructor() {
    this.organizations = [];
    this.features = [];
    this.is_super_user = false;
  }

  public hasAccess(feature: string, level= PermissionLevels.VIEW){

    if(this.is_super_user)
      return true

    const filteredArray = this.features.filter(obj => obj.name.toLowerCase() === feature.toLowerCase());

    if (filteredArray.length === 0)
      return false

    const access_level = filteredArray[0].level

    const hasPermission = (access_level & level) !== 0;

    return hasPermission
  }

  /**
   * Returns true if the user has access to the given feature OR any descendant of it.
   * Useful for sidebar visibility — e.g. show "Content Catalog" nav if user has "Collections".
   */
  public hasSomeAccess(feature: string, level = PermissionLevels.VIEW) {
    if (this.is_super_user) return true;

    const target = feature.toLowerCase();
    return this.features.some(f => {
      if ((f.level & level) === 0) return false;
      return f.name.toLowerCase() === target || f.path.some(p => p.toLowerCase() === target);
    });
  }

}


